var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('m-input',{staticClass:"search-form-field",attrs:{"nolabel":"","placeholder":"Firma Adı"},model:{value:(_vm.search.FIRMNAME),callback:function ($$v) {_vm.$set(_vm.search, "FIRMNAME", $$v)},expression:"search.FIRMNAME"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }